const implantology = {
  hero: {
    title: "ΕΜΦΥΤΕΥΜΑΤΟΛΟΓΙΑ",
    description:
      "Η οδοντιατρική κλινική μας προσφέρει υψηλής ποιότητας, μακροχρόνιες αντικαταστάσεις δοντιών που εξασφαλίζουν φυσική εμφάνιση και αίσθηση, εναρμονίζονται τέλεια με τα φυσικά σας δόντια και βελτιώνουν σημαντικά τη στοματική σας υγεία.",
    ctas: {
      bookConsultation: "Κλείστε Ραντεβού",
      learnMore: "Μάθετε Περισσότερα",
    },
    imageAlt: "Προηγμένα οδοντικά εμφυτεύματα",
    successRate: {
      title: "98% Ποσοστό Επιτυχίας",
      subtitle: "με τα προηγμένα εμφυτεύματά μας",
    },
  },
  benefits: {
    heading: "ΓΙΑΤΙ ΝΑ ΕΠΙΛΕΞΕΤΕ ΟΔΟΝΤΙΚΑ ΕΜΦΥΤΕΥΜΑΤΑ",
    intro:
      "Τα οδοντικά εμφυτεύματα προσφέρουν μια μόνιμη λύση για την απώλεια δοντιών, με οφέλη που ξεπερνούν την αισθητική.",
    items: [
      {
        title: "Φυσική Όψη & Αίσθηση",
        description:
          "Τα εμφυτεύματα προσφέρουν την ίδια σταθερότητα και εμφάνιση με τα φυσικά δόντια, επιτρέποντάς σας να χαμογελάτε, να μιλάτε και να τρώτε με αυτοπεποίθηση.",
      },
      {
        title: "Διατήρηση Οστικής Υγείας",
        description:
          "Σε αντίθεση με τις παραδοσιακές οδοντοστοιχίες, τα εμφυτεύματα διεγείρουν την ανάπτυξη του οστού και αποτρέπουν την απώλεια οστού που προκαλείται από την έλλειψη δοντιών.",
      },
      {
        title: "Μακροχρόνια Λύση",
        description:
          "Με τη σωστή φροντίδα, τα οδοντικά εμφυτεύματα μπορούν να διαρκέσουν μια ζωή, καθιστώντας τα μια οικονομικά αποδοτική λύση μακροπρόθεσμα.",
      },
    ],
  },
  process: {
    heading: "Η ΔΙΑΔΙΚΑΣΙΑ ΤΟΥ ΕΜΦΥΤΕΥΜΑΤΟΣ",
    intro:
      "Η οργανωμένη διαδικασία μας εξασφαλίζει ελάχιστη ενόχληση και μέγιστα αποτελέσματα.",
    steps: [
      {
        title: "Συμβουλευτική & Σχεδιασμός",
        description:
          "Ξεκινάμε με μια ολοκληρωμένη εξέταση χρησιμοποιώντας προηγμένη τρισδιάστατη απεικόνιση για να αξιολογήσουμε την στοματική σας υγεία και να δημιουργήσουμε ένα εξατομικευμένο σχέδιο θεραπείας.",
      },
      {
        title: "Τοποθέτηση Εμφυτεύματος",
        description:
          "Με τη χρήση τεχνολογίας αιχμής, τοποθετούμε προσεκτικά το εμφύτευμα τιτανίου στο οστό της γνάθου, το οποίο θα λειτουργήσει ως η \"ρίζα\" του νέου σας δοντιού.",
      },
      {
        title: "Επούλωση & Ενσωμάτωση",
        description:
          "Κατά τη διάρκεια 3 έως 6 μηνών, το εμφύτευμα ενώνεται με το οστό της γνάθου μέσω της διαδικασίας της οστεοενσωμάτωσης, δημιουργώντας ένα σταθερό θεμέλιο.",
      },
      {
        title: "Τελική Αποκατάσταση",
        description:
          "Μόλις ολοκληρωθεί η επούλωση, τοποθετούμε μια ειδικά κατασκευασμένη τεχνητή οδοντοστοιχία που ταιριάζει τέλεια με τα φυσικά σας δόντια σε χρώμα, σχήμα και μέγεθος.",
      },
    ],
  },
  faq: {
    heading: "ΣΥΧΝΕΣ ΕΡΩΤΗΣΕΙΣ",
    intro:
      "Λάβετε απαντήσεις σε κοινές ερωτήσεις σχετικά με τα οδοντικά εμφυτεύματα",
    items: [
      {
        question: "Είναι επώδυνα τα οδοντικά εμφυτεύματα;",
        answer:
          "Οι περισσότεροι ασθενείς αναφέρουν ότι η διαδικασία είναι λιγότερο επώδυνη απ' ό,τι περίμεναν. Χρησιμοποιούμε σύγχρονη αναισθησία και μεθόδους καταστολής για να διασφαλίσουμε την άνεσή σας σε όλη τη διάρκεια της διαδικασίας. Η ενόχληση μετά την επέμβαση είναι συνήθως ήπια και μπορεί να αντιμετωπιστεί με απλά παυσίπονα.",
      },
      {
        question: "Πόσο διαρκούν τα οδοντικά εμφυτεύματα;",
        answer:
          "Με σωστή φροντίδα και συντήρηση, τα οδοντικά εμφυτεύματα μπορούν να διαρκέσουν μια ζωή. Η οδοντοστοιχία μπορεί να χρειαστεί αντικατάσταση μετά από 10–15 χρόνια λόγω φυσικής φθοράς, όμως το ίδιο το εμφύτευμα μπορεί να παραμείνει ενσωματωμένο στο οστό επ' αόριστον.",
      },
      {
        question: "Είμαι κατάλληλος υποψήφιος για εμφυτεύματα;",
        answer:
          "Οι περισσότεροι ενήλικες με καλή γενική υγεία είναι κατάλληλοι υποψήφιοι για εμφυτεύματα. Σημαντικοί παράγοντες είναι η επαρκής πυκνότητα οστού για τη στήριξη του εμφυτεύματος και η καλή υγεία των ούλων. Κατά τη διάρκεια της εξέτασης, θα αξιολογήσουμε την κατάστασή σας και θα σας προτείνουμε τις κατάλληλες επιλογές.",
      },
      {
        question: "Πώς φροντίζω τα εμφυτεύματά μου;",
        answer:
          "Τα οδοντικά εμφυτεύματα απαιτούν την ίδια φροντίδα με τα φυσικά δόντια: τακτικό βούρτσισμα, χρήση οδοντικού νήματος και προληπτικούς οδοντιατρικούς ελέγχους. Αν και τα εμφυτεύματα δεν παθαίνουν τερηδόνα, οι ιστοί γύρω τους μπορεί να μολυνθούν χωρίς σωστή στοματική υγιεινή. Γι' αυτό, η καλή στοματική φροντίδα είναι απαραίτητη.",
      },
    ],
    cta: "Κλείστε Ραντεβού",
  },
};

export default implantology;

